import { getInfo, IEnvironment } from './i-environment';
import { ActiveSports } from './ActiveSports';

export const environment: IEnvironment = {
  version: getInfo().then(({ version }) => version),
  buildNumber: getInfo().then(({ build }) => build),
  production: true,
  api: 'https://smatchy-api-166402804090.europe-west9.run.app',
  firebaseConfig: {
    apiKey: 'AIzaSyBeG7lU_7druTlTLcHjiobbP3ROQx4cvfA',
    authDomain: 'smatchy-cc737.firebaseapp.com',
    projectId: 'smatchy-cc737',
    storageBucket: 'smatchy-cc737.appspot.com',
    messagingSenderId: '166402804090',
    appId: '1:166402804090:web:2a945daf5a7fec49acaec3',
    measurementId: '',
  },
  urlVoteNewSport: 'https://smatchy.quaeso.io/b/4/posts',
  googleApiKey: 'AIzaSyC2QyxNaF1bwzap6PLrAhgs_EA1Q1N1q3A',
  activeSports: ActiveSports,
  packageName: 'com.smatchy.app',
  sentryDsn: 'https://6850a19eb748423bc928e9929b2fb4dd@o4511901963517952.ingest.de.sentry.io/4511902062805072',
  smartLinkBaseUrl: 'https://smatchy.app',
  stripePublishableKey:
    'pk_live_51TVrHKIrb3gyJKusDGuuxyALPATC8J223OTPsPNcaXh6w6mxl3lfib4z2LFGlXPJ4giri1Q6pZI94q0FTHTrJLiW00sA6jGz16',
  appLink: {
    uri: '',
  },
  ios: {
    appStoreId: '',
    bundleId: '',
  },
};
